<template>
  <v-layout row wrap>
    <v-data-table v-model="selected" :search="search" :headers="headers" :items="specimena" :item-key="ID_KEY" select-all :pagination.sync="pagination" class="specimen-selection-table">
      <template v-slot:headers="props">
        <tr>
          <th>
            <v-checkbox color="primary" :input-value="props.all" :indeterminate="props.indeterminate" primary hide-details @click.stop="toggleAll" />
          </th>
          <th v-for="header in props.headers" :key="header.text" :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" @click="changeSort(header.value)">
            <v-icon small>arrow_upward</v-icon>
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr class="clickable" :active="props.selected" @click="props.selected = !props.selected ">
          <td>
            <v-checkbox @click.prevent color="info" hide-details :input-value="props.selected" />
          </td>
          <!-- <td>{{ props.item.ImportedSpeciesId }}</td> -->
          <td>{{ props.item.SpeciesCode }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-layout>
</template>

<script>
  const ID_KEY = 'Id'
  const SEARCH_KEY = 'Species'
  export default {
    props: {
      value: {
        type: Array,
        default: () => [],
      },
      specimena: {
        type: Array,
        default: () => [],
      },
      search: String,
    },
    data() {
      return {
        selected: [],
        ID_KEY,
        pagination: {
          sortBy: SEARCH_KEY,
          rowsPerPage: 10,
          page: 1,
        },
      }
    },
    computed: {
      allHeaders() {
        return {
          // speciesId: {
          //   text: 'Imported Species Id',
          //   align: 'left',
          //   value: 'ImportedSpeciesId',
          // },
          code: {
            text: 'Species',
            align: 'left',
            value: 'SpeciesCode',
          },
          // fullLatinName: {
          //   text: 'Latin Name',
          //   align: 'left',
          //   value: 'SpeciesFullLatinName',
          // },
        }
      },
      headers() {
        return Object.values(this.allHeaders)
      },
    },
    watch: {
      selected() {
        this.$emit('input', this.selected)
      },
    },
    methods: {
      toggleAll() {
        let selectedDict = {}
        this.selected.forEach(item => {
          selectedDict[item[ID_KEY]] = item
        })

        if (this.specimena.every(item => selectedDict[item[ID_KEY]])) {
          this.specimena.forEach(item => {
            delete selectedDict[item[ID_KEY]]
          })
        } else {
          this.specimena.forEach(item => {
            selectedDict[item[ID_KEY]] = item
          })
        }

        this.selected = Object.values(selectedDict)
      },
      changeSort(column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
    },
    created() {
      this.selected = this.value
    },
  }
</script>
<style scoped>
  .specimen-selection-table {
    flex: 1 1;
  }
</style>